<script setup lang="ts">
import OrgaElement, { type AddEntityType } from '~/components/orga/OrgaElement.vue'
import { useFormatLabel } from '~/composables/ui/useFormatLabel'

withDefaults(
  defineProps<{
    directionLib: string
    canMutate?: boolean
    inScope?: boolean
    codir: {
      label: string | undefined
      to?: string
      libLong?: string | null
      desc?: string | null
    }
  }>(),
  { canMutate: true, inScope: false },
)

const emit = defineEmits<{
  (event: 'add-click', payload: { entityType: AddEntityType; context?: Record<string, string | undefined> }): void
  (event: 'modify-click', context?: Record<string, string | undefined>): void
}>()

const { formatLabel } = useFormatLabel()
</script>

<template>
  <Transition name="fade-slide" appear>
    <div class="comex-bar comex-bar--animate" data-onboarding="direction-codir">
      <OrgaElement
        :label="formatLabel(codir?.label)"
        :to="codir?.to"
        :lib-long="codir?.libLong ?? null"
        :desc="codir?.desc ?? null"
        size="medium"
        header
        :add-entity-type="canMutate ? 'equipeDomaine' : undefined"
        add-label="Ajouter CODIR"
        :modify-kind="canMutate ? 'equipe' : undefined"
        :in-scope="inScope"
        :add-context="{ directionLib: directionLib, domaineLib: directionLib }"
        @add-click="emit('add-click', $event)"
        @modify-click="emit('modify-click', $event)"
      />
    </div>
  </Transition>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/orga/national-grid" as *;
@use "~/assets/scss/partials/orga/orga-page-animations" as motion;

@include motion.fade-slide-transitions;
@include motion.direction-page-animations;
</style>
